<template>
  <div class="start">
    <section class="hero is-fullheight">
      <div class="hero-header"><Navbar /></div>
      <div class="hero-body">

        <!-- Step 1 -->
        <div class="start__step container" v-if="step == 1">
            <div class="start__text">
                <p class="subtitle has-text-centered">Thank you for creating your Marketplace account.</p>
                <p class="subtitle has-text-centered has-padding-bottom-50">To complete your setup, please follow the next three steps.</p>
            </div>
            <div class="start__form">
                <h5 class="title is-5"><b class="is-purple-blue">Step 1:</b> Please enter your company name</h5>
                <div class="errors" v-if="errors.length">
                  <ul>
                    <li v-for="err in errors">
                      {{ err }}
                    </li>
                  </ul>
                </div>
                <b-field label="Please start typing your company name and select it from the list">
                    <b-autocomplete
                      :data="companyHouseResults"
                      field="title"
                      placeholder="e.g. BestAgent"
                      icon="search"
                      @select="setCompany"
                      @input="searchCompany"
                    >
                      <template slot="empty">No companies found</template>
                    </b-autocomplete>
                </b-field>
                <div v-if="showCompanyCard">
                    <div class="card company-card">
                        <div class="card-content">
                            <strong>{{ supplier.company.title }}</strong>
                            <br/>
                            {{ supplier.company.address_snippet }}
                        </div>
                    </div>
                    <div class="start__btn-next">
                        <a class="button btn-next" @click.prevent="nextStep(this)">Next</a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Step 2 -->
        <div class="start__step container" v-if="step == 2">
            <h5 class="title is-5"><b class="is-purple-blue">Step 2:</b> Please enter the authorised representative of {{ supplier.company.title }}</h5>
            <div class="has-text-left user-details">
                <div class="errors" v-if="errors.length">
                  <ul>
                    <li v-for="err in errors">
                      {{ err }}
                    </li>
                  </ul>
                </div>

                <b-field label="Name">
                    <b-input v-model="supplier.authorised.name"></b-input>
                </b-field>

                <b-field label="Job Title">
                    <b-input v-model="supplier.authorised.jobTitle"></b-input>
                </b-field>

                <b-field label="E-mail">
                    <b-input v-model="supplier.authorised.email" type="email"></b-input>
                </b-field>

                <b-field label="Phone Number">
                    <b-input v-model="supplier.authorised.phone"></b-input>
                </b-field>

                <div class="field">
                    <b-checkbox v-model="iamRepresentative">I confirm that I am an authorised representative of the above company</b-checkbox>
                </div>
            </div>
            <div class="start__btn-next">
                <a class="button btn-next" @click.prevent="nextStep(this)">Next</a>
            </div>
        </div>

        <!-- Step 3 -->
        <div class="start__step container" v-if="step == 3">
          <h5 class="title is-5"><b class="is-purple-blue">Step 3:</b> Please enter your general point of contact</h5>
          <div>Note: this should be the person who is available to liaise with BestAgent Marketplace on day to day matters e.g. Operations manager, Partner Relations manager</div>
          <div class="has-text-left user-details">
            <div class="errors" v-if="errors.length">
              <ul>
                <li v-for="err in errors">
                  {{ err }}
                </li>
              </ul>
            </div>
            <b-field label="Name">
              <b-input v-model="supplier.general.name"></b-input>
            </b-field>

            <b-field label="Job Title">
              <b-input v-model="supplier.general.jobTitle"></b-input>
            </b-field>

            <b-field label="E-mail">
              <b-input
                v-model="supplier.general.email"
                type="email"
              ></b-input>
            </b-field>

            <b-field label="Phone Number">
              <b-input v-model="supplier.general.phone"></b-input>
            </b-field>
          </div>
          <div class="start__btn-next">
              <a class="button btn-next" @click.prevent="nextStep(this)">Next</a>
          </div>
        </div>

        <!-- Thank you Step -->
        <div class="start__step container" v-if="step == 4">
          <div class="has-text-centered has-padding-bottom-30">
            <figure class="">
              <img class="start__clock-img" src="../assets/clock.png">
            </figure>
          </div>
          <p class="subtitle has-text-centered">Thank you for submitting your application.</p>
          <p class="subtitle has-text-centered">Your application will be reviewed shortly and if you are accepted we will notify you.  All genuine existing industry suppliers will be accepted.</p>
          <div class="start__btn-next">
              <a class="start__btn-marketplace button is-success btn-next" href="https://bestagent.co.uk/suppliers-faqs/">To Marketplace Homepage</a>
          </div>
        </div>

        <b-loading :is-full-page="true" :active="isLoading"></b-loading>

        <!-- Final Step -->
        <div class="start__step container has-text-centered" v-if="step == -1">
          <h1 class="title">Sorry, something went wrong...</h1>
          <h2>
            Please contact us at
            <a href="mailto:support@bestagent.ltd">support@bestagent.ltd</a>
          </h2>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios';
import api from '../libs/api';
import sendEvent from '../libs/sendEvent';
import Navbar from '@/components/Navbar.vue';
function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
export default {
  name: 'start',
  data() {
    return {
      step: 1,
      stepRequired: [
        {
          "Company": "that.supplier.company"
        },
        {
          "Please confirm you are an authorised representative.": "that.iamRepresentative",
          "Please enter a name": "that.supplier.authorised.name",
          "Email": "that.supplier.authorised.email",
          "Please enter a job title": "that.supplier.authorised.jobTitle",
          "Please enter a phone number": "that.supplier.authorised.phone"
        },
        {
          "Please enter a name": "that.supplier.general.name",
          "Email": "that.supplier.general.email",
          "Please enter a job title": "that.supplier.general.jobTitle",
          "Please enter a phone number": "that.supplier.general.phone"
        }
      ],
      errors:[],
      companyHouseResults: [],
      showCompanyCard: false,
      isLoading: false,
      iamRepresentative: false,
      supplier: {
        company: null,
        authorised: {
          name: '',
          email: '',
          jobTitle: '',
          phone: '',
        },
        general: {
          name: '',
          email: '',
          jobTitle: '',
          phone: '',
        },
        technical: {
          name: '',
          email: '',
          jobTitle: '',
          phone: '',
        },
      },
    };
  },
  components: {
    Navbar: () => import('../components/Navbar'),
  },
  async created() {
    this.supplier = await api({
      endpoint: `${process.env.VUE_APP_API}/suppliers`,
      path: '/info',
      method: 'GET',
    });
    if (this.supplier && this.supplier.active == true) {
      this.$router.push("/");
    }
    this.supplier.company = this.supplier.companyData;
    if (this.supplier.company && this.supplier.company.title != "") {
      this.step = 4;
    }
  },
  methods: {
    async nextStep(isto) {
      const that = this;
      this.isLoading = true;

      if (this.stepRequired[this.step-1]) {
        let required = [];
        const keys = Object.keys(this.stepRequired[this.step-1]);
        await Promise.all(keys.map(k => {
          try {
            let revar = eval(that.stepRequired[that.step-1][k]);
            if (!revar || revar == '') {
              required.push(k);
            } else if (k == 'Email' && !validateEmail(revar)) {
              required.push('Please validate the email address.');
            }
          } catch (e) {
            required.push(k);
          }
        }));
        if (required.length) {
          this.errors = required;
          this.isLoading = false;
          return false;
        }
      }
      this.errors = [];

      if (this.step == 3) {
        const saved = await this.saveSupplier();
        if (saved) {
          this.step += 1;
        } else {
          this.step = -1;
        }
      } else {
        this.step += 1;
      }
      this.isLoading = false;
    },
    searchCompany(input) {
      const self = this;
      axios
        .get(`${process.env.VUE_APP_API}/companies/companyHouse?q=${input}`)
        .then((response) => {
          self.companyHouseResults = response.data;
        })
        .catch(async (err) => {
          await sendEvent({
            type: 'ERROR-SUPPLIERS-FRONT-COMPANY-HOUSE',
            itemData: input,
            errorMessage: err,
          });
          console.error('Error:', err);
        });
    },
    setCompany(company) {
      if (company && company.hasOwnProperty('title')) {
        this.supplier.company = company;
        this.showCompanyCard = true;
      }
    },
    async saveSupplier() {
      try {
        await api({
          endpoint: `${process.env.VUE_APP_API}/suppliers`,
          path: '/',
          method: 'PUT',
          body: this.supplier,
        });
        return true;
      } catch (err) {
        await sendEvent({
          type: 'ERROR-SUPPLIERS-FRONT-SAVE-SUPPLIER',
          itemData: this.supplier,
          errorMessage: err,
        });
        console.log('Error:', err);
        return false;
      }
    },
  },
};
</script>

<style lang="scss">
.errors {
  color:red;
}
.errors ul {
  list-style-type: none;
}
.user-details {
  max-width: 400px;
  margin: 0 auto;
}
</style>
